import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "12",
  height: "10",
  viewBox: "0 0 12 10",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M11.668 2.16693C11.5568 2.0674 11.4217 2.00338 11.2782 1.98219C11.1347 1.961 10.9885 1.98349 10.8563 2.04708L10.1442 2.38653C9.17012 2.85089 8.00327 2.45872 7.50734 1.50029L6.96793 0.457844C6.89963 0.328911 6.80068 0.221688 6.68114 0.147094C6.56161 0.0725011 6.42577 0.0332031 6.28746 0.0332031C6.14915 0.0332031 6.01331 0.0725011 5.89378 0.147094C5.77425 0.221688 5.67529 0.328911 5.60699 0.457844L5.06758 1.50029C4.57165 2.45872 3.4048 2.85089 2.43068 2.38653L1.7186 2.04708C1.58615 1.98358 1.43977 1.96107 1.29602 1.98208C1.15226 2.0031 1.01685 2.06681 0.905103 2.16601C0.793353 2.26521 0.709718 2.39594 0.663652 2.54343C0.617587 2.69093 0.610927 2.84929 0.644426 3.00063L1.87899 8.64373C1.9026 8.75298 1.94665 8.85596 2.00847 8.94642C2.0703 9.03688 2.14861 9.11295 2.23867 9.17C2.36059 9.24824 2.49999 9.28966 2.64209 9.28985C2.71117 9.28971 2.77988 9.27919 2.84623 9.25858C5.09655 8.59161 7.47351 8.59161 9.72383 9.25858C9.9293 9.31649 10.1478 9.28464 10.3314 9.17C10.422 9.11367 10.5007 9.03783 10.5626 8.94725C10.6245 8.85667 10.6683 8.75333 10.6911 8.64373L11.9305 3.00063C11.9636 2.84925 11.9566 2.69096 11.9102 2.54363C11.8638 2.39631 11.7799 2.26583 11.668 2.16693Z",
  fill: "#262422"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }